import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SequencesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Sequences",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M18.26 11.08c1.25 0 2.27-1.02 2.27-2.27V4.28c0-1.26-1.02-2.28-2.27-2.28h-4.53c-1.25 0-2.26 1.02-2.26 2.27V8.8c0 1.25 1.02 2.27 2.27 2.27h.76v2.01h-.76c-1.25 0-2.27 1.02-2.27 2.27v4.53c0 1.25 1.02 2.27 2.27 2.27h.76v2.02h-2.28a.77.77 0 0 0-.65 1.18s3.74 4.27 3.74 4.27c.13.23.38.38.66.38s.53-.15.66-.38 3.74-4.27 3.74-4.27c.08-.12.13-.26.13-.42a.77.77 0 0 0-.77-.77h-2.22v-2.01h.76c1.25 0 2.27-1.02 2.27-2.27v-4.53c0-1.25-1.02-2.27-2.27-2.27h-.76v-2.01h.75Zm-.76 8.05h-3.02v-3.02h3.02zM14.48 8.05V5.03h3.02v3.02z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M9.86 11H3c-.63 0-1.14-.51-1.14-1.14V3c0-.63.51-1.14 1.14-1.14h6.86c.63 0 1.14.51 1.14 1.14v6.86c0 .63-.51 1.14-1.14 1.14M4.14 8.71h4.57V4.14H4.14zM28.14 11h-6.86c-.63 0-1.14-.51-1.14-1.14V3c0-.63.51-1.14 1.14-1.14h6.86c.63 0 1.14.51 1.14 1.14v6.86c0 .63-.51 1.14-1.14 1.14m-5.71-2.29H27V4.14h-4.57zM9.86 29.29H3c-.63 0-1.14-.51-1.14-1.14v-6.86c0-.63.51-1.14 1.14-1.14h6.86c.63 0 1.14.51 1.14 1.14v6.86c0 .63-.51 1.14-1.14 1.14M4.14 27h4.57v-4.57H4.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.29 7.57H9.86a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28M9.86 22.43c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62L20.48 9.05a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L10.67 22.1c-.22.22-.52.33-.81.33M28.14 25.86H9.86a1.14 1.14 0 1 1 0-2.28h18.28a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.57 30.43c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l3.76-3.76-3.76-3.76a1.14 1.14 0 0 1 0-1.62 1.15 1.15 0 0 1 1.62 0l4.57 4.57c.45.45.45 1.17 0 1.62l-4.57 4.57c-.22.22-.52.33-.81.33"
      })]
    })
  }));
};
SequencesIcon.displayName = 'SequencesIcon';